import constant from "../../constant";
import axios from "axios";
import router from "../../router";
const api = constant.api + "settings";
// initial state
const state = () => ({
  all: [],
  settings: [],
  setting: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getSetting: (state) => {
    return state.setting;
  },

  getSettings: (state) => {
    return state.settings;
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    await axios.get(api).then((response) => {
      let settings = response.data;
      commit("setSettings", settings);
    });
  },
  async show({ commit }, reference) {
    await axios.get(api + "/" + reference).then((response) => {
      let setting = response.data;
      commit("setSetting", setting);
    });
  },

  async store({ commit, dispatch }, data) {
    await axios.post(api, data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") router.push({ name: "settings-index" });
    });
  },
 
  async update({ dispatch }, data) {
    await axios.put(api + "/" + data.reference, data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });

      if (status == "success") {
        router.push({
          name: "settings-index",
        });
      }
    });
  },

  async destroy({ commit, dispatch }, reference) {
    await axios.delete(api + "/" + reference).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      let settings = response.data.data;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") commit("setSettings", settings);
    });
  },
};

// mutations
const mutations = {
  setSettings(state, settings) {
    state.all = settings;
    state.settings = settings;
  },
  setSetting(state, setting) {
    state.setting = setting;
  },
  
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
